import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { RequestChangePlanService } from './service/request-change-plan.service';
import { faAngleDown, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ShkDate } from 'shk-date';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ExcelService } from 'src/app/services/excel/excel.service';
import * as XLSX from 'xlsx-js-style';
import { ciInterface } from 'src/app/util/interfaces/ci';
import { forkJoin } from 'rxjs';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DotBounceLoadingEffectComponent } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.component';
import { GenericFormGenModule } from 'src/app/page_component_item/generic-form-gen/generic-form-gen.module';

@Component({
	standalone: true,
	imports: [CommonModule, FontAwesomeModule, GenericFormGenModule, DotBounceLoadingEffectComponent],
	selector: 'pcp-request-page-tab-change-plan',
	templateUrl: './request-change-plan.component.html',
	styleUrls: ['./request-change-plan.component.scss'],
})
export class RequestPageTabChangePlanComponent implements OnInit {
	@Input()
	idRequest: string;

	icons = {
		faAngleDown: faAngleDown,
		faTimes: faTimes,
	};

	labels: LabelsInterface = {
		lbl_projetos_descricao_alteracao: '',
		lbl_geral_motivo: '',
		lbl_impacto_durante_execucao: '',
		lbl_impacto_se_mudanca_nao_executada: '',
		lbl_geral_data_inicial: '',
		lbl_hora_inicial: '',
		lbl_geral_data_final: '',
		lbl_hora_final: '',
		lbl_detalhamento_change: '',
		lbl_pre_implementacao: '',
		lbl_implementacao: '',
		lbl_pos_implementacao: '',
		lbl_teste_e_validacao: '',
		lbl_role: '',
		lbl_geral_responsavel: '',
		lbl_geral_telefone: '',
		lbl_chamado_tarefa: '',
		lbl_geral_recurso: '',
		lbl_torre: '',
		lbl_geral_data_execucao: '',
		lbl_geral_hora: '',
		lbl_geral_duracao: '',
		lbl_geral_indisponibilidade: '',
		lbl_etapa: '',
		lbl_kb_criar: '',
		lbl_chamado_plano_acao: '',
		lbl_geral_atualizar: '',
		lbl_limpar_valores: '',
		lbl_horario_inicial_proxima_tarefa: '',
		lbl_preencha_todos_asteriscos: '',
		lbl_geral_criado_com_sucesso: '',
		lbl_successful_updated: '',
		lbl_inicio_mudanca_nao_pode_ser_maior_fim: '',
		lbl_tarefas_fora_periodo_mudanca: '',
		lbl_primeira_tarefa_implementacao_nao_pode_acontecer_antes_pre_implementacao_acabar: '',
		lbl_primeira_tarefa_pos_implementacao_nao_pode_acontecer_antes_implementacao_acabar: '',
		lbl_geral_exportar_dados: '',
	};

	idChangePlan = '';
	generalChangePlanFormDictionary = {};
	generalChangePlanForm: genericFormI[] = [
		{
			name: 'description',
			label: 'lbl_projetos_descricao_alteracao',
			inputType: 'textarea',
			required: true,
			values: [''],
			rawValues: [''],
			id: 'description',
		},
		{
			name: 'reason',
			label: 'lbl_geral_motivo',
			inputType: 'textarea',
			required: true,
			values: [''],
			rawValues: [''],
			id: 'reason',
		},
		{
			name: 'impactDuringExecution',
			label: 'lbl_impacto_durante_execucao',
			inputType: 'textarea',
			required: true,
			values: [''],
			rawValues: [''],
			id: 'impactDuringExecution',
		},
		{
			name: 'impactIfNotExecuted',
			label: 'lbl_impacto_se_mudanca_nao_executada',
			inputType: 'textarea',
			required: true,
			values: [''],
			rawValues: [''],
			id: 'impactIfNotExecuted',
		},
		{
			name: 'changeStartDate',
			label: 'lbl_geral_data_inicial',
			inputType: 'date',
			required: true,
			values: [],
			rawValues: [],
			id: 'changeStartDate',
		},
		{
			name: 'changeStartTime',
			label: 'lbl_hora_inicial',
			inputType: 'time',
			required: true,
			values: [''],
			rawValues: [''],
			id: 'changeStartTime',
		},
		{
			name: 'changeFinishDate',
			label: 'lbl_geral_data_final',
			inputType: 'date',
			required: true,
			values: [],
			rawValues: [],
			id: 'changeFinishDate',
		},
		{
			name: 'changeFinishTime',
			label: 'lbl_hora_final',
			inputType: 'time',
			required: true,
			values: [''],
			rawValues: [''],
			id: 'changeFinishTime',
		},
		{
			name: 'responsibles',
			label: 'lbl_geral_responsavel',
			inputType: 'multi-input',
			required: false,
			filterValues: [],
			values: [],
			rawValues: [],
			items: [
				{
					name: 'responsible',
					label: 'lbl_geral_responsavel',
					inputType: 'string',
					required: true,
					items: [],
					values: [''],
				},
				{
					name: 'function',
					label: 'lbl_role',
					inputType: 'string',
					required: true,
					values: [''],
				},
				{
					name: 'phone',
					label: 'lbl_geral_telefone',
					inputType: 'string',
					required: true,
					values: [''],
				},
				{
					name: 'email',
					label: 'E-mail',
					inputType: 'string',
					required: true,
					values: [''],
				},
			],
			id: 'responsibles',
		},
	];

	//ChangeTaskForm is used as a mold and is replicated on the tasks fields
	//to avoid rewriting the same form multiple times
	changeTaskForm: genericFormI[] = [
		{
			name: 'task',
			label: 'lbl_chamado_tarefa',
			inputType: 'multi-input',
			values: [],
			rawValues: [],
			filterValues: [],
			items: [
				{
					name: 'activity',
					label: 'lbl_geral_descricao',
					inputType: 'string',
					required: true,
					values: [''],
				},
				{
					name: 'resource',
					label: 'lbl_geral_recurso',
					inputType: 'select',
					values: [],
					items: [],
				},
				{
					name: 'tower',
					label: 'lbl_torre',
					inputType: 'string',
					required: false,
					values: [''],
				},
				{
					name: 'date',
					label: 'lbl_geral_data_execucao',
					inputType: 'date',
					required: true,
					values: [],
				},
				{
					name: 'time',
					label: 'lbl_geral_hora',
					inputType: 'time',
					required: true,
					values: [],
				},
				{
					name: 'duration',
					label: 'lbl_geral_duracao',
					inputType: 'time',
					required: true,
					values: [],
				},
				{
					name: 'indisponibility',
					label: 'lbl_geral_indisponibilidade',
					inputType: 'boolean',
					required: false,
					values: ['0'],
				},
			],
			id: 'task',
		},
	];

	preImplementForm: genericFormI[] = [];
	implementForm: genericFormI[] = [];
	posImplementForm: genericFormI[] = [];
	backoutForm: genericFormI[] = [];
	testingForm: genericFormI[] = [];

	cisForm: { ci: any; form: genericFormI[] }[] = [];

	constructor(
		private LabelsService: LabelsService,
		private RequestChangePlanService: RequestChangePlanService,
		private NotificationService: NotificationService,
		private ExcelService: ExcelService
	) {}

	isLoadingLabels = true;
	isLoadingForm = true;
	isLoadingChangePlanData = true;
	isLoadingCisChangePlanData = true;
	isUpdatingChangePlan = false;

	triggerRequired = false;

	ngOnInit(): void {
		if (!this.idRequest) {
			console.error('pcp-request-change-plan cannot be initialized without a idRequest');
			return;
		}

		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		for (const formItem of this.generalChangePlanForm) {
			this.generalChangePlanFormDictionary[formItem.name] = formItem;
		}

		this.preImplementForm = this.selectFields(['task', 'activity', 'resource', 'tower', 'date', 'time', 'duration', 'indisponibility']);
		this.implementForm = this.selectFields(['task', 'activity', 'resource', 'tower', 'date', 'time', 'duration', 'indisponibility']);
		this.posImplementForm = this.selectFields(['task', 'activity', 'resource', 'tower', 'date', 'time', 'duration', 'indisponibility']);
		this.backoutForm = this.selectFields(['task', 'activity', 'resource', 'tower', 'duration', 'indisponibility']);
		this.testingForm = this.selectFields(['task', 'activity', 'resource', 'tower', 'date', 'time', 'duration', 'indisponibility']);

		this.isLoadingForm = false;

		forkJoin([
			this.RequestChangePlanService.getChangePlan(this.idRequest),
			this.RequestChangePlanService.getRelatedCisChangePlan(this.idRequest),
		]).subscribe({
			next: (forkRes) => {
				const changePlanData = forkRes[0];
				const cisForm = forkRes[1];

				this.cisForm = cisForm;
				for (const ciForm of this.cisForm) {
					ciForm.form[1].hidden =
						ciForm.form[0].values.toString().toLowerCase() == 'true' || ciForm.form[0].values.toString() == '1' ? false : true;
				}

				if (changePlanData.idChangePlan == '') {
					this.isLoadingChangePlanData = false;
					return;
				}

				this.idChangePlan = changePlanData.idChangePlan;
				this.generalChangePlanFormDictionary['description'].values = changePlanData.description;
				this.generalChangePlanFormDictionary['reason'].values = changePlanData.reason;
				this.generalChangePlanFormDictionary['impactDuringExecution'].values = changePlanData.impact_during_execution;
				this.generalChangePlanFormDictionary['impactIfNotExecuted'].values = changePlanData.impact_not_executed;
				this.generalChangePlanFormDictionary['changeStartDate'].values = changePlanData.changeStartDate;
				this.generalChangePlanFormDictionary['changeStartTime'].values = changePlanData.changeStartTime;
				this.generalChangePlanFormDictionary['changeFinishDate'].values = changePlanData.changeFinishDate;
				this.generalChangePlanFormDictionary['changeFinishTime'].values = changePlanData.changeFinishTime;

				this.generalChangePlanFormDictionary['responsibles'].values = changePlanData.responsibles;
				this.generalChangePlanFormDictionary['responsibles'].outItems = changePlanData.responsibles;

				for (const resp of changePlanData.responsibles) {
					const newResp = {
						name: resp[0] + ', ' + resp[1],
						label: resp[0],
						values: [resp[0] + ' - ' + resp[1]],
					};
					const preImplementForm = this.preImplementForm[0].items.find((item) => item.name === 'resource');
					preImplementForm.items.push(newResp);

					const implementForm = this.implementForm[0].items.find((item) => item.name === 'resource');
					implementForm.items.push(newResp);

					const posImplementForm = this.posImplementForm[0].items.find((item) => item.name === 'resource');
					posImplementForm.items.push(newResp);

					const backoutForm = this.backoutForm[0].items.find((item) => item.name === 'resource');
					backoutForm.items.push(newResp);

					const testingForm = this.testingForm[0].items.find((item) => item.name === 'resource');
					testingForm.items.push(newResp);
				}

				this.preImplementForm[0].values = changePlanData.preImplement;
				this.preImplementForm[0].outItems = changePlanData.preImplement;

				this.implementForm[0].values = changePlanData.implement;
				this.implementForm[0].outItems = changePlanData.implement;

				this.posImplementForm[0].values = changePlanData.posImplement;
				this.posImplementForm[0].outItems = changePlanData.posImplement;

				this.backoutForm[0].values = changePlanData.backout;
				this.backoutForm[0].outItems = changePlanData.backout;

				this.testingForm[0].values = changePlanData.testing;
				this.testingForm[0].outItems = changePlanData.testing;

				this.setResponsiblesOnCi();
			},
			complete: () => {
				this.isLoadingChangePlanData = false;
				this.isLoadingCisChangePlanData = false;
			},
		});
	}

	selectFields(fields: string[]): genericFormI[] {
		const taskFormItem: genericFormI = JSON.parse(JSON.stringify(this.changeTaskForm[0]));
		for (let index = 0; index < taskFormItem.items.length; index++) {
			const item = taskFormItem.items[index];
			if (fields.includes(item.name)) continue;

			taskFormItem.items.splice(index, 1);
			index--;
		}

		if (fields.includes('date') && fields.includes('time')) {
			taskFormItem.beforeAdd = () => {
				if (taskFormItem.values.length <= 0) return true;

				let taskStartDate: genericFormI;
				let taskStartTime: genericFormI;
				let taskDuration: genericFormI;
				let taskStartDateIndex;
				let taskStartTimeIndex;
				let taskDurationIndex;

				for (const [index, item] of taskFormItem.items.entries()) {
					if (item.name == 'date') {
						taskStartDate = item;
						taskStartDateIndex = index;
					}
					if (item.name == 'time') {
						taskStartTime = item;
						taskStartTimeIndex = index;
					}
					if (item.name == 'duration') {
						taskDuration = item;
						taskDurationIndex = index;
					}
				}

				let newValueDateTime: any = new ShkDate(`${taskStartDate.values[0]} ${taskStartTime.values[0]}:00`).dateTime;
				newValueDateTime = new Date(newValueDateTime);

				const lastValueDateTime = new Date(
					new ShkDate(`${taskFormItem.values.at(-1)[taskStartDateIndex]} ${taskFormItem.values.at(-1)[taskStartTimeIndex]}:00`)
						.dateTime
				);
				const lastValueDurationToMs =
					(Number.parseInt(taskFormItem.values.at(-1)[taskDurationIndex].split(':')[0]) +
						(taskFormItem.values.at(-1)[taskDurationIndex].split(':')[1]
							? Math.floor(taskFormItem.values.at(-1)[taskDurationIndex].split(':')[1] / 60)
							: 0)) *
					60 *
					60 *
					1000;
				(<Date>lastValueDateTime).setTime((<Date>lastValueDateTime).getTime() + lastValueDurationToMs);

				if (newValueDateTime < lastValueDateTime) {
					this.NotificationService.setNotificationMessage(this.labels.lbl_horario_inicial_proxima_tarefa);
					return false;
				}

				return true;
			};
		}

		return [taskFormItem];
	}

	cleanFields(): void {
		this.generalChangePlanFormDictionary['description'].values = [''];
		this.generalChangePlanFormDictionary['reason'].values = [''];
		this.generalChangePlanFormDictionary['impactDuringExecution'].values = [''];
		this.generalChangePlanFormDictionary['impactIfNotExecuted'].values = [''];
		this.generalChangePlanFormDictionary['changeStartDate'].values = [''];
		this.generalChangePlanFormDictionary['changeStartTime'].values = [''];
		this.generalChangePlanFormDictionary['changeFinishDate'].values = [''];
		this.generalChangePlanFormDictionary['changeFinishTime'].values = [''];

		this.generalChangePlanFormDictionary['responsibles'].values = [];
		this.generalChangePlanFormDictionary['responsibles'].outItems = [];

		this.preImplementForm[0].values = [];
		this.preImplementForm[0].outItems = [];

		this.implementForm[0].values = [];
		this.implementForm[0].outItems = [];

		this.posImplementForm[0].values = [];
		this.posImplementForm[0].outItems = [];

		this.backoutForm[0].values = [];
		this.backoutForm[0].outItems = [];

		this.testingForm[0].values = [];
		this.testingForm[0].outItems = [];
	}

	checkAndCreateChangePlanBody(): any {
		this.triggerRequired = true;
		setTimeout(() => {
			this.triggerRequired = false;
		}, 10);

		if (
			!this.generalChangePlanFormDictionary['description'].values[0] ||
			this.generalChangePlanFormDictionary['description'].values[0] == '' ||
			!this.generalChangePlanFormDictionary['reason'].values[0] ||
			this.generalChangePlanFormDictionary['reason'].values[0] == '' ||
			!this.generalChangePlanFormDictionary['impactDuringExecution'].values[0] ||
			this.generalChangePlanFormDictionary['impactDuringExecution'].values[0] == '' ||
			!this.generalChangePlanFormDictionary['impactIfNotExecuted'].values[0] ||
			this.generalChangePlanFormDictionary['impactIfNotExecuted'].values[0] == '' ||
			!this.generalChangePlanFormDictionary['changeStartDate'].values[0] ||
			this.generalChangePlanFormDictionary['changeStartDate'].values[0] == '' ||
			!this.generalChangePlanFormDictionary['changeStartTime'].values[0] ||
			this.generalChangePlanFormDictionary['changeStartTime'].values[0] == '' ||
			!this.generalChangePlanFormDictionary['changeFinishDate'].values[0] ||
			this.generalChangePlanFormDictionary['changeFinishDate'].values[0] == '' ||
			!this.generalChangePlanFormDictionary['changeFinishTime'].values[0] ||
			this.generalChangePlanFormDictionary['changeFinishTime'].values[0] == '' ||
			this.generalChangePlanFormDictionary['responsibles'].values.length === 0
		) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return -1;
		}

		if (!this.checkAreFieldsProperlyFilled()) return;

		const responsibleItemsNames = [];
		for (const subField of this.generalChangePlanFormDictionary['responsibles'].items) {
			responsibleItemsNames.push(subField.name);
		}
		let taskItemNames = [];

		const body = {
			description: this.generalChangePlanFormDictionary['description'].values[0],
			reason: this.generalChangePlanFormDictionary['reason'].values[0],
			impact_during_execution: this.generalChangePlanFormDictionary['impactDuringExecution'].values[0],
			impact_not_executed: this.generalChangePlanFormDictionary['impactIfNotExecuted'].values[0],
			start_date: new ShkDate(
				`${this.generalChangePlanFormDictionary['changeStartDate'].values[0]} ${this.generalChangePlanFormDictionary['changeStartTime'].values[0]}:00`
			).dateTime,
			finish_date: new ShkDate(
				`${this.generalChangePlanFormDictionary['changeFinishDate'].values[0]} ${this.generalChangePlanFormDictionary['changeFinishTime'].values[0]}:00`
			).dateTime,
			responsibles: [], //this.generalChangePlanFormDictionary['responsibles'].values
			tasks: [],
			// , "preImplement": this.preImplementForm[0].values
			// , "implement": this.implementForm[0].values
			// , "posImplement": this.posImplementForm[0].values
			// , "backout": this.backoutForm[0].values
			// , "testing": this.testingForm[0].values
		};

		(<genericFormI>this.generalChangePlanFormDictionary['responsibles']).values.forEach((value: any[]) => {
			const temporary = {};
			for (const [index, itemValue] of value.entries()) {
				temporary[responsibleItemsNames[index]] = itemValue;
			}
			body.responsibles.push({ ...temporary });
		});

		taskItemNames = [];
		for (const subField of this.preImplementForm[0].items) {
			taskItemNames.push(subField.name);
		}
		this.preImplementForm[0].values.forEach((value: any[]) => {
			const temporary = {};
			temporary['task_step'] = 'preImplement';
			for (const [index, itemValue] of value.entries()) {
				temporary[taskItemNames[index]] = itemValue;
			}
			body.tasks.push({ ...temporary });
		});

		taskItemNames = [];
		for (const subField of this.implementForm[0].items) {
			taskItemNames.push(subField.name);
		}
		this.implementForm[0].values.forEach((value: any[]) => {
			const temporary = {};
			temporary['task_step'] = 'implement';
			for (const [index, itemValue] of value.entries()) {
				temporary[taskItemNames[index]] = itemValue;
			}
			body.tasks.push({ ...temporary });
		});

		taskItemNames = [];
		for (const subField of this.posImplementForm[0].items) {
			taskItemNames.push(subField.name);
		}
		this.posImplementForm[0].values.forEach((value: any[]) => {
			const temporary = {};
			temporary['task_step'] = 'posImplement';
			for (const [index, itemValue] of value.entries()) {
				temporary[taskItemNames[index]] = itemValue;
			}
			body.tasks.push({ ...temporary });
		});

		taskItemNames = [];
		for (const subField of this.backoutForm[0].items) {
			taskItemNames.push(subField.name);
		}
		this.backoutForm[0].values.forEach((value: any[]) => {
			const temporary = {};
			temporary['task_step'] = 'backout';
			for (const [index, itemValue] of value.entries()) {
				temporary[taskItemNames[index]] = itemValue;
			}
			body.tasks.push({ ...temporary });
		});

		taskItemNames = [];
		for (const subField of this.testingForm[0].items) {
			taskItemNames.push(subField.name);
		}
		this.testingForm[0].values.forEach((value: any[]) => {
			const temporary = {};
			temporary['task_step'] = 'testing';
			for (const [index, itemValue] of value.entries()) {
				temporary[taskItemNames[index]] = itemValue;
			}
			body.tasks.push({ ...temporary });
		});

		return body;
	}

	checkAndCreateCiChangePlanBody(): any {
		this.triggerRequired = true;
		setTimeout(() => {
			this.triggerRequired = false;
		}, 10);

		const body = [];

		for (const ci of this.cisForm) {
			const temporary = {};
			temporary['id'] = ci.ci.ci_change_plan;
			temporary['relationshipId'] = ci.ci.relationshipId;
			temporary['will_alter'] = ci.form[0].values[0] ? ci.form[0].values[0] : 0;
			temporary['alteration_desc'] = ci.form[1].values[0] ? ci.form[1].values[0] : '';
			temporary['customer'] = ci.form[2].values[0] ? ci.form[2].values[0] : '';
			temporary['affected_service'] = ci.form[3].values[0] ? ci.form[3].values[0] : '';
			temporary['down_time'] = ci.form[4].values[0] ? ci.form[4].values[0] : '';
			temporary['responsible'] = ci.form[5].values[0] ? ci.form[5].values[0] : '';
			temporary['geo_location'] = ci.form[6].values[0] ? ci.form[6].values[0] : '';
			temporary['class'] = ci.form[7].values[0] ? ci.form[7].values[0] : '';

			body.push(JSON.parse(JSON.stringify(temporary)));
		}

		return body;
	}

	createChangePlan(): void {
		const changePlanBody = this.checkAndCreateChangePlanBody();
		const ciChangePlanBody = this.checkAndCreateCiChangePlanBody();

		if (this.isUpdatingChangePlan || changePlanBody == -1 || ciChangePlanBody == -1) return;

		this.isUpdatingChangePlan = true;

		forkJoin([
			this.RequestChangePlanService.createChangePlan(this.idRequest, changePlanBody),
			this.RequestChangePlanService.createRelatedCisChangePlan(this.idRequest, ciChangePlanBody),
		]).subscribe({
			next: (forkRes) => {
				const changePlanRes = forkRes[0];
				const ciChangePlanRes = forkRes[1];

				this.idChangePlan = changePlanRes.idChangePlan;
				for (const [index, ci] of this.cisForm.entries()) {
					ci.ci.ci_change_plan = ciChangePlanRes.data[index];
				}
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
			},
			complete: () => {
				this.isUpdatingChangePlan = false;
			},
		});
	}

	updateChangePlan(): void {
		if (this.isUpdatingChangePlan) return;
		this.isUpdatingChangePlan = true;

		const changePlanBody = this.checkAndCreateChangePlanBody();
		const ciChangePlanBody = this.checkAndCreateCiChangePlanBody();

		const ciChangePlanToCreate = [];
		const ciChangePlanToUpdate = [];

		for (const ciChangePlan of ciChangePlanBody) {
			if (ciChangePlan.id == '-1') ciChangePlanToCreate.push(ciChangePlan);
			else ciChangePlanToUpdate.push(ciChangePlan);
		}

		forkJoin([
			this.RequestChangePlanService.updateChangePlan(this.idRequest, changePlanBody),
			this.RequestChangePlanService.createRelatedCisChangePlan(this.idRequest, ciChangePlanToCreate),
			this.RequestChangePlanService.updateRelatedCisChangePlan(this.idRequest, ciChangePlanToUpdate),
		]).subscribe({
			next: (forkRes) => {
				const createChangePlanRes = forkRes[1];
				for (const [index, ci] of this.cisForm.entries()) {
					if (ci.ci.id == '-1') ci.ci.ci_change_plan = createChangePlanRes.data[index];
				}
			},
			complete: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				this.isUpdatingChangePlan = false;
			},
		});
	}

	//Check if Change rules are properly filled, like task hours and such
	checkAreFieldsProperlyFilled(): boolean {
		const changeStartDate = new ShkDate(
			`${this.generalChangePlanFormDictionary['changeStartDate'].values[0]} ${this.generalChangePlanFormDictionary['changeStartTime'].values[0]}:00`
		);
		const changeFinishDate = new ShkDate(
			`${this.generalChangePlanFormDictionary['changeFinishDate'].values[0]} ${this.generalChangePlanFormDictionary['changeFinishTime'].values[0]}:00`
		);
		if (new Date(changeStartDate.dateTime) > new Date(changeFinishDate.dateTime)) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_inicio_mudanca_nao_pode_ser_maior_fim);
			(<genericFormI>this.generalChangePlanFormDictionary['changeStartDate']).alert = true;
			(<genericFormI>this.generalChangePlanFormDictionary['changeStartTime']).alert = true;
			(<genericFormI>this.generalChangePlanFormDictionary['changeFinishDate']).alert = true;
			(<genericFormI>this.generalChangePlanFormDictionary['changeFinishTime']).alert = true;
			return false;
		}

		const stepNames = ['preImplement', 'implement', 'posImplement', 'testing'];
		for (const stepName of stepNames) {
			const stepFormTaskField: genericFormI = this[stepName + 'Form'][0];
			if (stepFormTaskField.values.length > 0) {
				const firstTaskDate = new ShkDate(`${stepFormTaskField.values[0][3]} ${stepFormTaskField.values[0][4]}:00`);
				const lastTaskDate = new ShkDate(`${stepFormTaskField.values.at(-1)[3]} ${stepFormTaskField.values.at(-1)[4]}:00`);

				if (
					new Date(firstTaskDate.dateTime) < new Date(changeStartDate.dateTime) ||
					new Date(firstTaskDate.dateTime) > new Date(changeFinishDate.dateTime) ||
					new Date(lastTaskDate.dateTime) < new Date(changeStartDate.dateTime) ||
					new Date(lastTaskDate.dateTime) > new Date(changeFinishDate.dateTime)
				) {
					this.NotificationService.setNotificationMessage(`${stepName} ${this.labels.lbl_tarefas_fora_periodo_mudanca}`);
					stepFormTaskField.alert = true;
					false;
					continue;
				}
			}
		}

		const preImplementFormTaskField: genericFormI = this.preImplementForm[0];
		const implementFormTaskField: genericFormI = this.implementForm[0];
		const posImplementFormTaskField: genericFormI = this.posImplementForm[0];

		if (preImplementFormTaskField.values.length > 0 && implementFormTaskField.values.length > 0) {
			const lastPreImplementTaskDate = new Date(
				new ShkDate(`${preImplementFormTaskField.values.at(-1)[3]} ${preImplementFormTaskField.values.at(-1)[4]}:00`).dateTime
			);
			const firstImplementTaskDate = new Date(
				new ShkDate(`${implementFormTaskField.values[0][3]} ${implementFormTaskField.values[0][4]}:00`).dateTime
			);

			const lastValueDurationToMs =
				(Number.parseInt(preImplementFormTaskField.values.at(-1)[5].split(':')[0]) +
					(preImplementFormTaskField.values.at(-1)[5].split(':')[1]
						? Math.floor(preImplementFormTaskField.values.at(-1)[5].split(':')[1] / 60)
						: 0)) *
				60 *
				60 *
				1000;
			(<Date>lastPreImplementTaskDate).setTime((<Date>lastPreImplementTaskDate).getTime() + lastValueDurationToMs);

			if (firstImplementTaskDate < lastPreImplementTaskDate) {
				// preImplementFormTaskField.alert = true;
				// implementFormTaskField.alert = true;
				this.NotificationService.setNotificationMessage(
					this.labels.lbl_primeira_tarefa_implementacao_nao_pode_acontecer_antes_pre_implementacao_acabar
				);
				return false;
			}
		}

		if (implementFormTaskField.values.length > 0 && posImplementFormTaskField.values.length > 0) {
			const lastImplementTaskDate = new Date(
				new ShkDate(`${implementFormTaskField.values.at(-1)[3]} ${implementFormTaskField.values.at(-1)[4]}:00`).dateTime
			);
			const firstPosImplementTaskDate = new Date(
				new ShkDate(`${posImplementFormTaskField.values[0][3]} ${posImplementFormTaskField.values[0][4]}:00`).dateTime
			);

			const lastValueDurationToMs =
				(Number.parseInt(implementFormTaskField.values.at(-1)[5].split(':')[0]) +
					(implementFormTaskField.values.at(-1)[5].split(':')[1]
						? Math.floor(implementFormTaskField.values.at(-1)[5].split(':')[1] / 60)
						: 0)) *
				60 *
				60 *
				1000;
			(<Date>lastImplementTaskDate).setTime((<Date>lastImplementTaskDate).getTime() + lastValueDurationToMs);

			if (firstPosImplementTaskDate < lastImplementTaskDate) {
				// implementFormTaskField.alert = true;
				// posImplementFormTaskField.alert = true;
				this.NotificationService.setNotificationMessage(
					this.labels.lbl_primeira_tarefa_pos_implementacao_nao_pode_acontecer_antes_implementacao_acabar
				);
			}
		}

		return true;
	}

	exportToExcel(): void {
		const generalData = [];
		const descriptionField: genericFormI = this.generalChangePlanFormDictionary['description'];
		const reasonField: genericFormI = this.generalChangePlanFormDictionary['reason'];
		const impactDuringExecutionField: genericFormI = this.generalChangePlanFormDictionary['impactDuringExecution'];
		const impactIfNotExecutedField: genericFormI = this.generalChangePlanFormDictionary['impactIfNotExecuted'];
		const changeStartDateField: genericFormI = this.generalChangePlanFormDictionary['changeStartDate'];
		const changeStartTimeField: genericFormI = this.generalChangePlanFormDictionary['changeStartTime'];
		const changeFinishDateField: genericFormI = this.generalChangePlanFormDictionary['changeFinishDate'];
		const changeFinishTimeField: genericFormI = this.generalChangePlanFormDictionary['changeFinishTime'];
		const responsiblesField: genericFormI = this.generalChangePlanFormDictionary['responsibles'];

		let temporary = [];
		temporary.push(this.labels[descriptionField.label]);
		generalData.push(temporary);
		temporary = [];
		temporary.push(descriptionField.values[0]);
		generalData.push(temporary, []);
		temporary = [];

		temporary.push(this.labels[reasonField.label]);
		generalData.push(temporary);
		temporary = [];
		temporary.push(reasonField.values[0]);
		generalData.push(temporary, []);
		temporary = [];

		temporary.push(this.labels[impactDuringExecutionField.label]);
		generalData.push(temporary);
		temporary = [];
		temporary.push(impactDuringExecutionField.values[0]);
		generalData.push(temporary, []);
		temporary = [];

		temporary.push(this.labels[impactIfNotExecutedField.label]);
		generalData.push(temporary);
		temporary = [];
		temporary.push(impactIfNotExecutedField.values[0]);
		generalData.push(temporary, []);
		temporary = [];

		temporary.push(this.labels[changeStartDateField.label], changeStartDateField.values[0]);
		generalData.push(temporary);
		temporary = [];
		temporary.push(this.labels[changeStartTimeField.label], changeStartTimeField.values[0]);
		generalData.push(temporary, []);
		temporary = [];

		temporary.push(this.labels[changeFinishDateField.label], changeFinishDateField.values[0]);
		generalData.push(temporary);
		temporary = [];
		temporary.push(this.labels[changeFinishTimeField.label], changeFinishTimeField.values[0]);
		generalData.push(temporary, []);
		temporary = [];

		temporary.push(this.labels[responsiblesField.label]);
		generalData.push(temporary);
		temporary = [];
		for (const responsibleItem of responsiblesField.items) {
			temporary.push(this.labels[responsibleItem.label] ? this.labels[responsibleItem.label] : responsibleItem.label);
		}
		generalData.push(temporary);
		for (const responsibleValue of responsiblesField.values) {
			generalData.push(responsibleValue);
		}
		temporary = [];

		const preImplementData = [];
		temporary.push(this.labels[this.preImplementForm[0].label]);
		preImplementData.push(temporary);
		temporary = [];
		for (const taskItem of this.preImplementForm[0].items) {
			temporary.push(this.labels[taskItem.label]);
		}
		preImplementData.push(temporary);
		for (const taskValue of this.preImplementForm[0].values) {
			preImplementData.push(taskValue);
		}
		temporary = [];

		const implementData = [];
		temporary.push(this.labels[this.implementForm[0].label]);
		implementData.push(temporary);
		temporary = [];
		for (const taskItem of this.implementForm[0].items) {
			temporary.push(this.labels[taskItem.label]);
		}
		implementData.push(temporary);
		for (const taskValue of this.implementForm[0].values) {
			implementData.push(taskValue);
		}
		temporary = [];

		const posImplementData = [];
		temporary.push(this.labels[this.posImplementForm[0].label]);
		posImplementData.push(temporary);
		temporary = [];
		for (const taskItem of this.posImplementForm[0].items) {
			temporary.push(this.labels[taskItem.label]);
		}
		posImplementData.push(temporary);
		for (const taskValue of this.posImplementForm[0].values) {
			posImplementData.push(taskValue);
		}
		temporary = [];

		const backoutData = [];
		temporary.push(this.labels[this.backoutForm[0].label]);
		backoutData.push(temporary);
		temporary = [];
		for (const taskItem of this.backoutForm[0].items) {
			temporary.push(this.labels[taskItem.label]);
		}
		backoutData.push(temporary);
		for (const taskValue of this.backoutForm[0].values) {
			backoutData.push(taskValue);
		}
		temporary = [];

		const testingData = [];
		temporary.push(this.labels[this.testingForm[0].label]);
		testingData.push(temporary);
		temporary = [];
		for (const taskItem of this.testingForm[0].items) {
			temporary.push(this.labels[taskItem.label]);
		}
		testingData.push(temporary);
		for (const taskValue of this.testingForm[0].values) {
			testingData.push(taskValue);
		}
		temporary = [];

		const generalWorksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(generalData, { skipHeader: true });
		const preImplementWorksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(preImplementData, { skipHeader: true });
		const implementWorksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(implementData, { skipHeader: true });
		const posImplementWorksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(posImplementData, { skipHeader: true });
		const backoutWorksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(backoutData, { skipHeader: true });
		const testingWorksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(testingData, { skipHeader: true });
		const documentStyle = document.documentElement.style;
		const headerStyle = {
			font: { sz: 12, bold: true, color: { rgb: 'FFFFFF' } },
			fill: { fgColor: { rgb: documentStyle.getPropertyValue('--primary-color-2').replace('#', '') } },
		};
		const subHeaderStyle = {
			font: { sz: 12, bold: true, color: { rgb: 'FFFFFF' } },
			fill: { fgColor: { rgb: documentStyle.getPropertyValue('--primary-color-1').replace('#', '') } },
		};
		generalWorksheet['A1'].s = headerStyle;
		generalWorksheet['A4'].s = headerStyle;
		generalWorksheet['A7'].s = headerStyle;
		generalWorksheet['A10'].s = headerStyle;
		generalWorksheet['A13'].s = headerStyle;
		generalWorksheet['A14'].s = headerStyle;
		generalWorksheet['A16'].s = headerStyle;
		generalWorksheet['A17'].s = headerStyle;
		generalWorksheet['A19'].s = headerStyle;
		generalWorksheet['A20'].s = subHeaderStyle;
		generalWorksheet['B20'].s = subHeaderStyle;
		generalWorksheet['C20'].s = subHeaderStyle;
		generalWorksheet['D20'].s = subHeaderStyle;
		//generalWorksheet["E20"].s = subHeaderStyle;

		preImplementWorksheet['A1'].s = headerStyle;
		preImplementWorksheet['A2'].s = subHeaderStyle;
		preImplementWorksheet['B2'].s = subHeaderStyle;
		preImplementWorksheet['C2'].s = subHeaderStyle;
		preImplementWorksheet['D2'].s = subHeaderStyle;
		preImplementWorksheet['E2'].s = subHeaderStyle;
		preImplementWorksheet['F2'].s = subHeaderStyle;
		preImplementWorksheet['G2'].s = subHeaderStyle;

		implementWorksheet['A1'].s = headerStyle;
		implementWorksheet['A2'].s = subHeaderStyle;
		implementWorksheet['B2'].s = subHeaderStyle;
		implementWorksheet['C2'].s = subHeaderStyle;
		implementWorksheet['D2'].s = subHeaderStyle;
		implementWorksheet['E2'].s = subHeaderStyle;
		implementWorksheet['F2'].s = subHeaderStyle;
		implementWorksheet['G2'].s = subHeaderStyle;

		posImplementWorksheet['A1'].s = headerStyle;
		posImplementWorksheet['A2'].s = subHeaderStyle;
		posImplementWorksheet['B2'].s = subHeaderStyle;
		posImplementWorksheet['C2'].s = subHeaderStyle;
		posImplementWorksheet['D2'].s = subHeaderStyle;
		posImplementWorksheet['E2'].s = subHeaderStyle;
		posImplementWorksheet['F2'].s = subHeaderStyle;
		posImplementWorksheet['G2'].s = subHeaderStyle;

		backoutWorksheet['A1'].s = headerStyle;
		backoutWorksheet['A2'].s = subHeaderStyle;
		backoutWorksheet['B2'].s = subHeaderStyle;
		backoutWorksheet['C2'].s = subHeaderStyle;
		backoutWorksheet['D2'].s = subHeaderStyle;
		backoutWorksheet['E2'].s = subHeaderStyle;

		testingWorksheet['A1'].s = headerStyle;
		testingWorksheet['A2'].s = subHeaderStyle;
		testingWorksheet['B2'].s = subHeaderStyle;
		testingWorksheet['C2'].s = subHeaderStyle;
		testingWorksheet['D2'].s = subHeaderStyle;
		testingWorksheet['E2'].s = subHeaderStyle;
		testingWorksheet['F2'].s = subHeaderStyle;
		testingWorksheet['G2'].s = subHeaderStyle;

		const workbook: XLSX.WorkBook = {
			Sheets: {
				general: generalWorksheet,
				preImplement: preImplementWorksheet,
				implement: implementWorksheet,
				posImplement: posImplementWorksheet,
				backout: backoutWorksheet,
				testing: testingWorksheet,
			},
			SheetNames: ['general', 'preImplement', 'implement', 'posImplement', 'backout', 'testing'],
		};
		const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

		this.ExcelService.saveAsExcelFile(excelBuffer, 'change_plan_' + this.idRequest);
	}

	setResponsiblesOnCi(): void {
		const responsibleNameArray: string[] = [];
		const responsibleArray: genericFormI[] = [];
		const responsiblesField = this.generalChangePlanFormDictionary['responsibles'];

		for (const responsible of responsiblesField.values) {
			const newResponsible = new genericFormI('item');
			newResponsible.name = responsible[0];
			newResponsible.label = responsible[0];
			newResponsible.values = [responsible[0]];

			if (!responsibleNameArray.includes(responsible[0])) {
				responsibleArray.push(newResponsible);
				responsibleNameArray.push(responsible[0]);
			}
		}

		const preImplementResponsibleFormItem = this.preImplementForm[0].items.find((multiInputItem) => {
			return multiInputItem.name == 'resource';
		});
		if (preImplementResponsibleFormItem != undefined) preImplementResponsibleFormItem.items = responsibleArray;

		const implementResponsibleFormItem = this.implementForm[0].items.find((multiInputItem) => {
			return multiInputItem.name == 'resource';
		});
		if (implementResponsibleFormItem != undefined) implementResponsibleFormItem.items = responsibleArray;

		const posImplementResponsibleFormItem = this.posImplementForm[0].items.find((multiInputItem) => {
			return multiInputItem.name == 'resource';
		});
		if (posImplementResponsibleFormItem != undefined) posImplementResponsibleFormItem.items = responsibleArray;

		const backoutResponsibleFormItem = this.backoutForm[0].items.find((multiInputItem) => {
			return multiInputItem.name == 'resource';
		});
		if (backoutResponsibleFormItem != undefined) backoutResponsibleFormItem.items = responsibleArray;

		const testingResponsibleFormItem = this.testingForm[0].items.find((multiInputItem) => {
			return multiInputItem.name == 'resource';
		});
		if (testingResponsibleFormItem != undefined) testingResponsibleFormItem.items = responsibleArray;

		for (const ciField of this.cisForm) {
			ciField.form[5].items = responsibleArray;
		}
	}
}
